import { Howl } from 'howler'
import spinSoundEffect from 'pages/RouletteGame/audios/ballSpin.mp3'

const spinSound = new Howl({
    src: spinSoundEffect,
    loop: false
})

export const playRouletteSpinSound = () => {
    spinSound.currentTime = 0
    spinSound?.play()
}

export const stopRouletteSpinSound = () => {
    spinSound?.stop()
}